// import React, { useRef, useState } from "react";
// import { Form as BSForm, Button } from "react-bootstrap";
// import { useDropzone } from "react-dropzone";

// export default function ImageUploaderWithPreview({ imageFile, onUpload }) {
//   const [imagePreview, setImagePreview] = useState(null);
//   const [file, setFile] = useState(null);
//   const inputRef = useRef();

//   const onDrop = (acceptedFiles) => {
//     if (acceptedFiles && acceptedFiles.length > 0) {
//       const uploadedFile = acceptedFiles[0];
//       setFile(uploadedFile);
//       const previewURL = URL.createObjectURL(uploadedFile);
//       setImagePreview(previewURL);
//       if (onUpload) onUpload(uploadedFile);
//     }
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     multiple: false,
//     accept: { "image/*": [".jpg", ".jpeg", ".png", ".webp"] },
//   });

//   const handleFileSelect = (e) => {
//     const uploadedFile = e.target.files[0];
//     if (uploadedFile) {
//       setFile(uploadedFile);
//       const previewURL = URL.createObjectURL(uploadedFile);
//       setImagePreview(previewURL);
//       if (onUpload) onUpload(uploadedFile);
//     }
//   };

//   const openFileDialog = () => {
//     inputRef.current.click();
//   };

//   const handleRemove = () => {
//     setFile(null);
//     setImagePreview(null);
//     if (onUpload) onUpload(null);
//   };

//   return (
//     <div>
//       <BSForm.Label>Upload Product Image</BSForm.Label>

//       <div
//         {...getRootProps()}
//         onClick={openFileDialog}
//         className={`border rounded p-4 text-center cursor-pointer ${
//           isDragActive ? "bg-light border-primary" : "border-secondary"
//         }`}
//         style={{
//           borderStyle: "dashed",
//           transition: "0.2s ease",
//         }}
//       >
//         <input {...getInputProps()} />
//         <input
//           type="file"
//           ref={inputRef}
//           hidden
//           onChange={handleFileSelect}
//           accept="image/*"
//         />
//         {imagePreview ? (
//           <div>
//             <img
//               src={imagePreview}
//               alt="Preview"
//               className="img-fluid mb-2"
//               style={{ maxHeight: 200 }}
//             />
//             <div>
//               <Button
//                 variant="danger"
//                 size="sm"
//                 onClick={(e) => {
//                   e.stopPropagation(); // 👈 Prevent click from bubbling to parent
//                   handleRemove();
//                 }}
//               >
//                 Remove Image
//               </Button>
//             </div>
//           </div>
//         ) : (
//           <p
//             className="text-muted"
//             style={{
//               minHeight: "80px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             Click or drag an image here to upload (JPG, PNG, WEBP)
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }



import React, { useState, useRef } from 'react';
import { Form as BSForm, Button } from 'react-bootstrap';
import { useDropzone } from 'react-dropzone';

export default function ImageUploaderWithPreview({
  imageUrl,          // 👈 Existing image URL (optional)
  onUpload,          // 👈 Callback with new file
  disabled = false   // 👈 To optionally disable upload
}) {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [editing, setEditing] = useState(false); // 👈 toggles edit mode
  const inputRef = useRef();

  const onDrop = (acceptedFiles) => {
    const uploadedFile = acceptedFiles[0];
    if (uploadedFile) {
      const previewURL = URL.createObjectURL(uploadedFile);
      setFile(uploadedFile);
      setPreview(previewURL);
      setEditing(true);
      if (onUpload) onUpload(uploadedFile);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setFile(null);
    setPreview(null);
    setEditing(true);
    if (onUpload) onUpload(null);
  };

  const openFileDialog = () => {
    inputRef.current.click();
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: { 'image/*': ['.jpg', '.jpeg', '.png', '.webp'] },
  });

  const showUploadUI = editing || (!imageUrl && !preview);

  return (
    <div>
      <BSForm.Label>Product Image</BSForm.Label>

      {showUploadUI ? (
        <div
          {...getRootProps()}
          onClick={openFileDialog}
          className={`border rounded p-4 text-center cursor-pointer ${
            isDragActive ? 'bg-light border-primary' : 'border-secondary'
          }`}
          style={{ borderStyle: 'dashed', transition: '0.2s ease' }}
        >
          <input {...getInputProps()} />
          <input
            type="file"
            ref={inputRef}
            hidden
            onChange={(e) => {
              if (e.target.files[0]) onDrop([e.target.files[0]]);
            }}
            accept="image/*"
          />

          {preview ? (
            <div>
              <img
                src={preview}
                alt="Preview"
                className="img-fluid mb-2"
                style={{ maxHeight: 200 }}
              />
              <div>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleRemove}
                  disabled={disabled}
                >
                  Remove Image
                </Button>
              </div>
            </div>
          ) : (
            <p className="text-muted">Click or drag an image here to upload</p>
          )}
        </div>
      ) : (
        <div className="text-center">
          <img
            src={imageUrl}
            alt="Current"
            className="img-fluid mb-2"
            style={{ maxHeight: 200 }}
          />
          <div>
            <Button
              variant="warning"
              size="sm"
              onClick={() => setEditing(true)}
              disabled={disabled}
            >
              Change Image
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

